import { CoreType } from "../../Core/Core.Interfaces";
import { GenericTableSchemaInterface } from "../../Table/Table.Interfaces";
import { VarKey } from "../../Variables/Generated/VarKey.Data";

export const AccountBalance00Table: GenericTableSchemaInterface = {
  id: "account-balance-00",
  name: "Account Balance 00",
  description: "This table contains data around the account balance integration.",
  core: CoreType.STORAGE,
  mapping: {
    c01: {
      name: "Operator Name",
      variable: VarKey.OrgName
    },
    c02: {
      name: "Facility ID",
      variable: VarKey.LocationFMSId
    },
    c03: {
      name: "Facility Name",
      variable: VarKey.LocationName
    },
    c04: {
      name: "Location Number",
      variable: VarKey.LocationLocationNumber
    },
    c05: {
      name: "Start"
    },
    c06: {
      name: "Get Tenant Started"
    },
    c07: {
      name: "Tenant Found"
    },
    c08: {
      name: "Account Balance Found"
    },
    c09: {
      name: "Account Status Active"
    },
    c10: {
      name: "Account Status Inactive"
    },
    c11: {
      name: "Account Status Unknown"
    },
    c12: {
      name: "Account Status Else"
    },
    c13: {
      name: "SMS Sent"
    },
    c14: {
      name: "SMS Invalid Phone Number"
    },
    c15: {
      name: "Email Sent"
    },
    c16: {
      name: "LLM Used"
    },
    c17: {
      name: "Account Balance",
      variable: VarKey.LeaseBalance
    },
    c18: {
      name: "SMS Link Clicked"
    }
  }
};
